import React from "react";
import { ConfigProvider, Select, Button, message } from "antd";
import "./device-menu.css";
import { ReloadOutlined } from "@ant-design/icons";
import { getSessions, getSessionsList } from "../../api/common";
import { DEVICE_TYPE_MAP } from "@/consts/enums";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";

class DeviceMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            deviceOptions: [],
            selectedDevice: null,
        };
        this.sessionData = [];
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        // this.timer = null; // 定时器引用
    }

    handleToggle() {
        this.setState({ isOpen: !this.state.isOpen });
    }

    handleClose() {
        this.setState({ isOpen: false });
    }

    initData = async () => {
        this.setState({
            deviceValue: null,
        });
        try {
            const resp = await getSessionsList();
            // console.log("resplog: ", resp);
            
            // 处理 API 响应，确保 sessionData 是数组
            // API 可能返回 { code: 200, data: [...], message: 'success' } 或直接返回数组
            let sessionsArray = Array.isArray(resp) ? resp : (resp?.data || resp?.sessions || []);
            
            // 确保最终结果是数组
            if (!Array.isArray(sessionsArray)) {
                sessionsArray = [];
                console.warn('API response is not an array:', resp);
            }
            
            this.sessionData = sessionsArray;
            const { intl } = this.props;
            this.setState({
                deviceOptions: this.sessionData.map((item) => ({
                    session_id: item.sessionId?item.sessionId:null,
                    value: item.macAddress,
                    deviceType: item.deviceType,
                    label: (
                        <span>
                            {item.macAddress}
                            {`(${
                                DEVICE_TYPE_MAP[String(item.deviceType)] ||
                                intl.formatMessage({
                                    id: 'gui.deviceMenu.unknownDevice',
                                    defaultMessage: 'Unknown Device'
                                })
                            })`}
                        </span>
                    ),
                })),
            });
            message.success(intl.formatMessage({
                id: 'gui.deviceMenu.refreshSuccess',
                defaultMessage: 'Device refresh successful'
            }));
            // console.log("resplog: ", resp);
        } catch (error) {
            console.log("error: ", error);
            message.error(intl.formatMessage({
                id: 'gui.deviceMenu.refreshFailed',
                defaultMessage: 'Failed to refresh devices'
            }));
        }
    };

    componentDidMount() {
        this.initData();
        // 每隔30秒执行一次 initData
        // this.timer = setInterval(this.initData, 30000);

        // Set initial costume based on saved device
        this.initializeCostume();
        
        // 监听设备类型恢复事件（从项目文件加载时）
        this.props.vm.on('DEVICE_TYPE_RESTORE', this.handleDeviceTypeRestore);
    }
    
    // 处理从项目文件恢复设备类型
    handleDeviceTypeRestore = (deviceType) => {
        console.log("[DEBUG] 接收到设备类型恢复事件:", deviceType);
        
        // 首先尝试在已加载的设备列表中查找
        const deviceOption = this.state.deviceOptions.find(
            item => item.deviceType === deviceType
        );
        
        if (deviceOption) {
            // 如果设备在线，正常选择
            console.log("[DEBUG] 找到在线设备:", deviceOption);
            this.handleChangeDevice(deviceOption.value);
        } else {
            // 如果设备不在线，直接设置 localStorage 并刷新积木面板
            console.log("[DEBUG] 设备不在线，直接设置设备类型:", deviceType);
            
            // 构造一个临时的设备数据
            const tempDeviceData = {
                deviceType: deviceType,
                value: null,
                session_id: null,
                label: DEVICE_TYPE_MAP[String(deviceType)] || 'Unknown'
            };
            
            // 保存到 localStorage
            localStorage.setItem("selectedDeviceData", JSON.stringify(tempDeviceData));
            
            // 刷新工作区和积木面板
            setTimeout(() => {
                this.props.vm.refreshWorkspace();
                console.log("[DEBUG] 已刷新工作区，积木面板应该已更新为设备类型", deviceType);
            }, 100);
        }
    }

    initializeCostume = () => {
        try {
            const storedData = localStorage.getItem("selectedDeviceData");
            if (storedData) {
                const curDevice = JSON.parse(storedData);
                const costumeIndex = this.getDeviceCostumeIndex(
                    curDevice.deviceType
                );
                const spriteName = this.getDeviceSpriteName(
                    curDevice.deviceType
                );

                // Find the first sprite (non-stage target)
                const targets = this.props.vm.runtime.targets;
                const sprite = targets.find((target) => !target.isStage);

                if (sprite) {
                    if (sprite.sprite.costumes.length > costumeIndex) {
                        sprite.setCostume(costumeIndex);
                    }
                    sprite.sprite.name = spriteName;
                    this.props.vm.emitTargetsUpdate();
                }
            }
        } catch (error) {
            console.log("Error initializing costume:", error);
        }
    };

    componentWillUnmount() {
        // 组件卸载时清除定时器
        // if (this.timer) {
        //     clearInterval(this.timer);
        //     this.timer = null;
        // }
        
        // 移除设备类型恢复事件监听
        this.props.vm.off('DEVICE_TYPE_RESTORE', this.handleDeviceTypeRestore);
    }

    // Device type to costume index mapping
    getDeviceCostumeIndex = (deviceType) => {
        const index = DEVICE_TYPE_MAP.getValues().indexOf(String(deviceType));
        return index === -1 ? 0 : index;
    };

    // Device type to sprite name mapping
    getDeviceSpriteName = (deviceType) => {
        const { intl } = this.props;
        return (
            DEVICE_TYPE_MAP[String(deviceType)] ||
            intl.formatMessage({
                id: "gui.SpriteInfo.spritePlaceholder",
                defaultMessage: "Sprite",
            })
        );
    };

    handleChangeDevice = (val) => {
        if (val) {
            const curDevice = this.state.deviceOptions.find(
                (item) => item.value === val
            );

            localStorage.setItem(
                "selectedDeviceData",
                JSON.stringify(curDevice)
            );

            // Change costume and name based on device type
            const costumeIndex = this.getDeviceCostumeIndex(
                curDevice.deviceType
            );
            const spriteName = this.getDeviceSpriteName(curDevice.deviceType);

            // Find the first sprite (non-stage target)
            const targets = this.props.vm.runtime.targets;
            const sprite = targets.find((target) => !target.isStage);

            if (sprite) {
                if (sprite.sprite.costumes.length > costumeIndex) {
                    sprite.setCostume(costumeIndex);
                }
                // Update sprite name
                sprite.sprite.name = spriteName;
                this.props.vm.emitTargetsUpdate();
            }

            this.props.vm.refreshWorkspace();
            console.log("设备选择");
            console.log(curDevice.deviceType);
            // target.blocks._blocks
        } else {
            localStorage.removeItem("selectedDeviceData");

            // Reset to default costume and name when device is cleared
            const targets = this.props.vm.runtime.targets;
            const sprite = targets.find((target) => !target.isStage);

            if (sprite) {
                if (sprite.sprite.costumes.length > 0) {
                    sprite.setCostume(0);
                }
                // Reset sprite name to default
                sprite.sprite.name = this.getDeviceSpriteName(1);
                this.props.vm.emitTargetsUpdate();
            }

            this.props.vm.refreshWorkspace();
        }
        this.setState({
            deviceValue: val,
        });
    };

    render() {
        const { deviceOptions, deviceValue } = this.state;
        const { intl } = this.props;
        return (
            <div style={{ marginRight: "40px" }}>
                <div
                    className="my-select-label"
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <span>
                        <FormattedMessage
                            id="gui.deviceMenu.connectedDevice"
                            defaultMessage="Connected Device："
                        />
                    </span>
                    <Select
                        placeholder={intl.formatMessage({
                            id: 'gui.deviceMenu.selectDevicePlaceholder',
                            defaultMessage: 'Please select a connected device'
                        })}
                        allowClear
                        style={{ width: "255px", border: "none" }}
                        value={deviceValue}
                        options={deviceOptions}
                        onClear={() => this.setState({ deviceValue: null })}
                        onSelect={this.handleChangeDevice}
                    />
                    <ReloadOutlined
                        onClick={this.initData}
                        title={intl.formatMessage({
                            id: 'gui.deviceMenu.refreshTooltip',
                            defaultMessage: 'Refresh device list'
                        })}
                        className="rfresh_device_button"
                        style={{
                            fontSize: "24px",
                            marginLeft: "10px",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, { asset, id }) => ({
    vm: state.scratchGui.vm,
});

const mapDispatchToProps = (dispatch) => ({});

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(DeviceMenu)
);
